import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.saved;

const getSaved = createSelector(getData, saved => saved);

export default getSaved;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getSaved.js